import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
import ICONS from '../config/icon';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';
import Steps from './Steps'
import SectionAnmelden from "./SectionAnmelden";

function Course() {
  const { slug } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Funktion zur Formatierung des Startdatums
  const formatStartDate = (dateString) => {
    if (!dateString) return 'Datum nicht angegeben'; // Fallback für leeres Datum
    const date = new Date(dateString); // Konvertiere das Datum in ein Date-Objekt
    return format(date, 'dd. MMMM yyyy', { locale: de }); // Formatieren im deutschen Stil
  };

  useEffect(() => {
    if (!slug) {
      setError('Ungültige Kurs-URL.');
      setLoading(false);
      return;
    }

    // API-Aufruf für den Kurs basierend auf dem Slug
    fetch(`https://www.denisbitter.de/stage01/get_courses.php/${slug}/with-skills`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Fehler beim Laden der Kursdaten.');
        }
        return response.json();
      })
      .then((data) => {
        setCourse(data); // Kursdaten setzen
        setLoading(false);
      })
      .catch((error) => {
        console.error('Fehler beim Laden der Kursdaten:', error);
        setError(error.message);
        setLoading(false);
      });
  }, [slug]);

  if (loading) return <p>Lade Kursdetails...</p>;
  if (error) return <p>{error}</p>;
  if (!course) return <p>Der Kurs wurde nicht gefunden.</p>;

  // Hole das Icon aus der config/icon.js, falls vorhanden, oder zeige ein Fallback
  

  return (
    <div className="min-h-screen bg-gradient-to-r from-purple-50 to-blue-50 text-black">
      <div className="container mx-auto px-6 py-16 text-center max-w-2xl">
        {/* Titel mit Icon */}
        <div className="flex flex-col items-center md:flex-row md:justify-center md:items-center">
            <div className="text-5xl mb-4 md:mb-0 md:mr-4">      
            </div>

          <h1 className="text-xl md:text-4xl font-normal">{course.title}</h1>
        </div>
        <div className="flex flex-col items-center">
    <span className="text-orange-50 text-lg mb-2">★★★★★</span>
    <p className="text-gray-800 mt-1">
      Mehr als {course.ratingValue || '0'}% der Teilnehmer<br />bewerten diesen Kurs als "Super"
    </p>
  </div>
        <p className="mt-5 md:text-xl ">
          {course.description?.join(' ')}
        </p>

        {/* Externer Container für zentrierte Darstellung */}
        <div className="mt-10 flex flex-col md:grid md:grid-cols-3 items-center max-w-2xl mx-auto text-sm mb-8">
          {/* Rechtes Grid: Sterne und Bewertung */}
          <div className="flex flex-col items-center text-center order-2 md:order-1 md:text-center md:pl-4">
  
</div>
          {/* Linkes Grid: Startdatum und Registrierungen */}
          <div className="flex flex-col items-center text-center order-1 md:order-3 md:text-right md:pr-4 text-2xl">
            <p className="text-orange-50 font-semibold whitespace-nowrap">
              Start ab {formatStartDate(course.startDate)}
            </p>
            <p className="text-gray-800 whitespace-nowrap text-sm">
              {course.registeredCount || '0'} Teilnehmer bereits absloviert
            </p>
          </div>
        </div>

       
        {/* Anmeldebutton mit Verlinkung */}
        <div className="flex items-center justify-center space-x-4">
  {/* Anmeldebutton mit Verlinkung */}
  <Link
    to={`/anmeldung/${slug}`}
    className="bg-pink-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-gray-800 transition duration-300"
  >
    Anmelden
  </Link>
  
  {/* Zweiter Button mit Verlinkung */}
  <Link
    to="/kontakt"
    className="bg-blue-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-gray-800 transition duration-300"
  >
    Fragen?
  </Link>
</div>

        {/* Navigationsleiste */}
        <div className="hidden md:flex justify-center space-x-6 text-gray-800 font-semibold mt-8 mb-8">
          <a href="#skills" className="hover:underline">Lerninhalte</a>
          <a href="#program" className="hover:underline">	Kursdetails</a>
          <a href="#testimonials" className="hover:underline">Erfahrungen</a>
          <a href="#teachers" className="hover:underline">Trainer Coach</a>
          <a href="#price" className="hover:underline">Paketpreis</a>
        </div>
      </div>

{/* Videoabschnitt - Video aus der API laden */}
<section id="video" className="py-16 container mx-auto text-center">
  <h2 className="text-2xl font-bold mb-0"></h2>
  {course.videoUrl ? (
    <div className="relative pb-[56.25%] mb-4"> {/* 16:9 Aspect Ratio */}
      <iframe
        src={course.videoUrl.replace('watch?v=', 'embed/')} // YouTube-URL für Embed-Modus umwandeln
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="absolute top-0 left-0 w-full h-full rounded-lg"
      ></iframe>
    </div>
  ) : (
    <p className="text-gray-800">Kein Video verfügbar</p>
  )}
</section>



{/* Zielabschnitt: Skills You Get */}
<section id="skills" className="py-16 container mx-auto text-center text-orange-50 px-4 sm:px-6 md:px-8">
  <h2 className="text-2xl font-bold mb-4">Werkzeuge</h2>
  <p className="text-gray-800 mb-8">Du lernst authentisch die wichtigsten Fähigkeiten in allen Möglichkeiten</p>

  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
    {Array.isArray(course.skills) && course.skills.length > 0 ? (
      course.skills.map((skill, index) => (
        <div
          key={index}
          className="relative bg-gray-800 text-white rounded-xl shadow-xl p-6 flex flex-col h-80 overflow-hidden group cursor-pointer"
        >
          {/* Zahl und Icon nebeneinander */}
          <div className="flex items-center justify-start space-x-2 mb-4">
            <div className="text-4xl sm:text-5xl font-bold text-orange-50">
              {String(index + 1).padStart(2, '0')}
            </div>
            <div className="text-4xl sm:text-5xl">
              {React.cloneElement(ICONS[skill.icon] || ICONS.default, { className: 'text-4xl sm:text-5xl' })}
            </div>
          </div>

          {/* Text unter dem Icon */}
          <div className="text-left">
            <h1 className="text-lg font-semibold text-orange-50">{skill.name}</h1>
            
          </div>

          {/* Inhalt beim Hover */}
          <div className="absolute bottom-0 left-0 right-0 p-4 bg-gray-900 transition-transform duration-300 transform translate-y-full group-hover:translate-y-0 rounded-xl shadow-xl">
            <div className="text-left pl-2">
            <p className="text-sm sm:text-base font-bold text-teal-500 leading-snug">{skill.description}</p>
              <p className="text-white ">{skill.skillExample}</p>
            </div>
          </div>
        </div>
      ))
    ) : (
      <p className="text-gray-800 flex justify-center items-center">Keine Skills verfügbar</p>
    )}
  </div>
</section>




{/* Kursbalauf  */}
      <section id="program" className="py-16 container mx-auto text-center text-orange-50">
        <h2 className="text-2xl font-bold mb-4">Deine Kursablauf</h2>
        <p className="text-gray-800">Hier ist das Programm des Kurses...</p>
      </section>

      <section id="testimonials" className="py-16 container mx-auto text-center text-orange-50">
        <h2 className="text-2xl font-bold mb-4">Wie läuft es ab?</h2>
      
      </section>
      <Steps />
      
      <section id="teachers" className="py-16 container mx-auto text-center  text-orange-50">
        <h2 className="text-2xl font-bold mb-4">Die Köpfe</h2>
        <p className="text-gray-800">Die Instruktoren des Kurses sind...</p>
      </section>

      <section id="price" className="py-16 container mx-auto text-center  text-orange-50">
        <h2 className="text-2xl font-bold mb-4">Dein Kurs Preis</h2>
        <p className="text-gray-800">{course.price || 'Preis auf Anfrage'}</p>
      </section>
      <SectionAnmelden />
    </div>
  );
}

export default Course;